/*!
    * @product/scmp-sdk 2.0.2
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-QHSZACEQ.js.map
